// Схема локальной базы ядра. Живёт в коде, а не в файлах миграций: база клиента одноразовая — если
// что-то пошло не так, её проще перезалить с сервера, чем чинить. Версия нужна, чтобы понять, когда
// именно перезаливать (§4.2 документа 09).

/** Версия схемы. Поднимается при любом несовместимом изменении — старая база тогда пересоздаётся. */
export const schemaVersion = 6;

/**
 * Идентификаторы везде TEXT: снежинки не помещаются в число с плавающей точкой, а на проводе они и так
 * строки (ADR-024). Время — миллисекунды Unix в INTEGER: сортировать и сравнивать проще, чем строки.
 */
export const schema = `
CREATE TABLE IF NOT EXISTS chats (
  id             TEXT PRIMARY KEY,
  kind           INTEGER NOT NULL,
  title          TEXT    NOT NULL DEFAULT '',
  updated_at     INTEGER NOT NULL DEFAULT 0,
  last_message_id TEXT,
  unread         INTEGER NOT NULL DEFAULT 0,
  archived       INTEGER NOT NULL DEFAULT 0,
  muted          INTEGER NOT NULL DEFAULT 0,
  pinned         INTEGER NOT NULL DEFAULT 0,
  -- Число участников: в шапке чата человек ждёт состав группы, а не счётчик сообщений.
  member_count   INTEGER NOT NULL DEFAULT 0
);

CREATE TABLE IF NOT EXISTS members (
  chat_id TEXT NOT NULL REFERENCES chats(id) ON DELETE CASCADE,
  address TEXT NOT NULL,
  role    INTEGER NOT NULL DEFAULT 0,
  -- До какого сообщения человек прочитал (событие ReadUpdated, поле Member.last_read_message_id).
  -- Пусто — не знаем: отметку он ещё не присылал. «Не знаем» и «не прочитал» — разные вещи, и
  -- вторая галочка не ставится ни в том, ни в другом случае.
  last_read_message_id TEXT NOT NULL DEFAULT '',
  PRIMARY KEY (chat_id, address)
);

-- Сообщения: и пришедшие с сервера, и ещё не отправленные. Своё сообщение живёт под client_msg_id,
-- пока сервер не вернёт своё — тогда строка получает id и состояние меняется на sent (§4 задания Р-09).
CREATE TABLE IF NOT EXISTS messages (
  id             TEXT PRIMARY KEY,
  chat_id        TEXT NOT NULL REFERENCES chats(id) ON DELETE CASCADE,
  client_msg_id  TEXT NOT NULL DEFAULT '',
  sender         TEXT NOT NULL DEFAULT '',
  kind           INTEGER NOT NULL DEFAULT 1,
  text           TEXT NOT NULL DEFAULT '',
  created_at     INTEGER NOT NULL DEFAULT 0,
  edited_at      INTEGER,
  deleted        INTEGER NOT NULL DEFAULT 0,
  state          TEXT NOT NULL DEFAULT 'sent',  -- pending | sent | failed
  reply_to_id    TEXT,
  -- Контракт 0.14: тело пустое не потому, что его нет, а потому, что не расшифровалось. Без этого
  -- признака сообщение-файл без подписи и испорченное сообщение выглядят одинаково.
  unreadable     INTEGER NOT NULL DEFAULT 0,
  -- Системное событие (Message.system) как оно пришло: тип, кто, кого и значение, в JSON. Фразу
  -- собирает клиент из словаря Дизайна: узел с зашитыми русскими фразами закрыл бы второй язык
  -- навсегда, а три клиента, сочиняющие каждый по-своему, дали бы три разных продукта.
  system         TEXT NOT NULL DEFAULT '',
  -- Реакции (эмодзи, счётчик, «моя ли») как их отдаёт узел, в JSON: читаются всегда вместе с
  -- сообщением и по отдельности не ищутся.
  reactions      TEXT NOT NULL DEFAULT ''
);
CREATE INDEX IF NOT EXISTS ix_messages_chat ON messages(chat_id, created_at, id);
CREATE UNIQUE INDEX IF NOT EXISTS ux_messages_client ON messages(chat_id, client_msg_id)
  WHERE client_msg_id <> '';

CREATE TABLE IF NOT EXISTS files (
  id       TEXT PRIMARY KEY,
  name     TEXT NOT NULL DEFAULT '',
  mime     TEXT NOT NULL DEFAULT '',
  size     INTEGER NOT NULL DEFAULT 0,
  local_path TEXT
);

-- Очередь исходящих: что ушло в сеть, но ещё не подтверждено, и что ждёт повтора после ошибки.
CREATE TABLE IF NOT EXISTS outbox (
  client_msg_id TEXT PRIMARY KEY,
  chat_id       TEXT NOT NULL,
  payload       TEXT NOT NULL,          -- JSON запроса: что именно отправить
  attempts      INTEGER NOT NULL DEFAULT 0,
  next_attempt_at INTEGER NOT NULL DEFAULT 0,
  last_error    TEXT NOT NULL DEFAULT ''
);
CREATE INDEX IF NOT EXISTS ix_outbox_due ON outbox(next_attempt_at);

-- Состояние ядра: курсор стрима, версия схемы, адрес пользователя. Одна строка на ключ.
CREATE TABLE IF NOT EXISTS state (
  key   TEXT PRIMARY KEY,
  value TEXT NOT NULL
);
`;
